import { createSelector } from 'reselect';
import { HEXON_DOMAIN } from './constants';
import { initialState } from './reducer';

const selectHEXONDomain = state => state[HEXON_DOMAIN] || initialState;

export function selectHexonAds() {
    return createSelector(
      selectHEXONDomain,
      HEXON => HEXON.ads,
    );
  }

  export function selectHexonControlPanelUrl() {
    return createSelector(
      selectHEXONDomain,
      HEXON => HEXON.controlPanelUrl,
    );
  }
    